import {gql} from "@apollo/client";
import { ChannelType } from './getChannel'

export const GET_ALL_CHANNEL = gql`
    query ChannelQuery{
        getAllChannels{
            id
            channelName
            companyName
            companyAddress
            contactName
            contactPhone
            email
            taxRate
            taxId
            status
            remark
        }
    }
`;

export interface allChannelResponse {
    getAllChannels: ChannelType[];
}